import { QueryManagerItem } from '@/packages'
import { VirtualListContainer, VirtualListItems } from './list'
import { VirtualListProvider } from './context'
import { QueryItem } from '@codeleap/query'

export function createVirtualList<T extends QueryItem, F>() {
  return {
    Container: VirtualListContainer,
    Provider: VirtualListProvider<T, F>,
    Items: VirtualListItems<T>,
  }
}
